import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';
import { whatsappAPI } from '../../api';
import ConversationList from './ConversationList';
import ChatView from './ChatView';

const WhatsAppConversations = () => {
  const { state } = useApp();
  const { translations } = useTranslations();
  const t = translations[state.currentLanguage];

  const [selectedConversation, setSelectedConversation] = useState(null);

  const handleConversationSelect = (conversation) => {
    setSelectedConversation(conversation);
  };

  const handleSendMessage = async (phoneNumber, message) => {
    try {
      console.log('Sending message via WhatsAppConversations:', { phoneNumber, message });
      await whatsappAPI.sendMessage(state.token, phoneNumber, message);
      console.log('Message sent successfully');
    } catch (error) {
      console.error('Error sending message:', error);
      throw error; // Re-throw to let ChatView handle the error
    }
  };

  return (
    <div className="whatsapp-conversations">
      <div className="conversations-container">
        <ConversationList
          onConversationSelect={handleConversationSelect}
          selectedConversation={selectedConversation}
        />
        <ChatView
          conversation={selectedConversation}
          onSendMessage={handleSendMessage}
        />
      </div>
    </div>
  );
};

export default WhatsAppConversations;
